module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAA1ElEQVRoQ+2ZQQ6AIBAD8T3+/yf+B48eTDQbd6HU8Yx126khhK33vrcfPRuGzWlD2BxwgzCEzRKg0mZAb3YgDGGzBCKVPhy8Y/iBIoRXrHik0iv6Yx+GsEVvH0xAGMJmCVBpM6Dsw1S6qNIyB49RhDFc1KRXWQi/RrT4glGEZWLCsAyKokEgXBSsjCyEZVAUDQLhomBlZCHM3dKVgMwR78v/Eak0hr8kPevdCOFZM6Z+F8OpcQqKQVgQSupIEE6NU1AMwoJQUkeCcGqcgmIQFoSSOtIJDnPHjcHRpTIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-daohang.png
// module id = +sL+
// module chunks = 1